import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Popover, PopoverContent, PopoverTrigger } from "@vertesia/ui/core";
import { useUserSession } from "@vertesia/ui/session";
import { Download } from "lucide-react";
import { useUITranslation } from '../../i18n/index.js';
import { getResourceUrl } from "./MagicPdfProvider";
export function DownloadPopover({ object }) {
    const { t } = useUITranslation();
    const { client } = useUserSession();
    const onDownload = (name) => {
        getResourceUrl(client, object.id, name).then(url => window.open(url, '_blank'));
    };
    const getProcessorType = () => {
        if (object.metadata?.type === "document") {
            const docMetadata = object.metadata;
            return docMetadata.content_processor?.type || "xml";
        }
        return "xml"; // default
    };
    const processorType = getProcessorType();
    const buttonClass = "p-2 cursor-pointer hover:bg-muted text-left text-sm";
    // For markdown processor, only one download option - render simple button
    if (processorType === "markdown") {
        return (_jsx(Button, { variant: "ghost", size: "xs", onClick: () => onDownload("document.md"), alt: t('pdf.download'), children: _jsx(Download, { className: 'size-4' }) }));
    }
    // Default XML processor - multiple options, use popover
    return (_jsxs(Popover, { children: [_jsx(PopoverTrigger, { children: _jsx(Button, { variant: "ghost", size: "xs", alt: t('pdf.download'), children: _jsx(Download, { className: 'size-4' }) }) }), _jsx(PopoverContent, { align: "start", className: "p-0 w-auto", children: _jsxs("div", { className: "min-w-[200px] flex flex-col divide-y divide-border", children: [_jsx("button", { className: buttonClass, onClick: () => onDownload("annotated.pdf"), children: "annotated.pdf" }), _jsx("button", { className: buttonClass, onClick: () => onDownload("document.xml"), children: "document.xml" }), _jsx("button", { className: buttonClass, onClick: () => onDownload("analyzed-pages.json"), children: "analyzed-pages.json" })] }) })] }));
}
//# sourceMappingURL=DownloadPopover.js.map